/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody
} from 'mdb-react-ui-kit';

import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';
import { isTokenPresent } from '../utils/auth';
import User from '../utils/Interface/User';

import Menu from '../components/Menu';
import Header from '../components/Header';
import Button from '../components/Button';
import TableUsers from '../components/TableUsers';
import InputField from '../components/InputField';
import NewAttribution from '../components/NewAttribution';

import '../style/css/materials.css';
import '../style/css/users.css';
import '../style/index.css';

const Users: React.FC = () => {

  const { userName, specialToken } = useSpecialToken();
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [filteredData, setFilteredData] = useState<User[]>([]);
  const [searchValue2, setSearchValue2] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [dataUser, setDataUser] = useState<User[]>([]);
  const [Visible, setVisible] = useState(false);
  const [optXlModal, setOptXlModal] = useState(false);
  const [events, setEvents] = useState<React.FormEvent<HTMLFormElement> | null>(null);


// Useffect and fetchData

  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    } else if  (!specialToken) {
      return; // Si specialToken est null ou non défini, ne rien faire
    } else {
      fetchData();
    }
  }, [specialToken]);

 

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('sessionToken');
      if (!token) {
        throw new Error('Token not found in local storage');
      }

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
    }
    
  

      const response = await fetch(apiRoutes.UsersGetAll, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
      });

      if (!response.ok) throw new Error('Erreur lors de la récupération des données');

      const jsonData = await response.json();
      setDataUser(jsonData);
      setFilteredData(jsonData);
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };

  const handlePreventDefault = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (events) {
      handlePreventDefault(events);
    }
  }, [events]);
  const handleUserSelection = (user: User) => {
    setSelectedUser(user);
  };

  const handleSearch = () => {
    const searchTerm = searchValue.toLowerCase().trim();

    const filteredData = dataUser.filter((user) => {
      const nameMatch = user.user_name && user.user_name.toLowerCase().includes(searchTerm);
      const firstnameMatch = user.user_firstname && user.user_firstname.toLowerCase().includes(searchTerm);
      const realnameMatch = user.user_realname && user.user_realname.toLowerCase().includes(searchTerm);
      return nameMatch || firstnameMatch || realnameMatch;
    });

    setFilteredData(filteredData);
    setVisible(true);
  };

  const handleSearch2 = () => {
    const searchTerm = searchValue2.toLowerCase().trim();
    console.log(searchTerm);
    console.log(searchValue2);
    
    const filteredData = dataUser.filter((user) => {
      const nameEntityMatch = user.entity_name && user.entity_name.toLowerCase().includes(searchTerm);
      return nameEntityMatch;
    });

    setFilteredData(filteredData);
    setVisible(true);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    setSearchValue2('');
    setFilteredData(dataUser);
    setVisible(false);
  };

  const toggleOpen = () => setOptXlModal(!optXlModal);



  return (

    <div className="mainusers">

      <div className="mainusers__box1">

        <Header userName={userName} />

        <div className="mainusers__box1__container">

          <h2 className="mainusers__box1__container__title">Recherche d'utilisateurs</h2>

          <div className="mainusers__box1__container__btns">

            <form className="maininvmat__box1__container__lay__form">

              <InputField
              labels={[{ title: 'Entité' }]}
              onChange={(newValue) => setSearchValue2(newValue[0])}
              initialValue={[searchValue2]}
              readOnly={false}/>

              <InputField
              labels={[{ title: 'Utilisateur' }]}
              onChange={(newValue) => setSearchValue(newValue[0])}
              initialValue={[searchValue]}
              readOnly={false} />

            </form>

            <Button 
            btnName="RECHERCHER" 
            onClick={() => searchValue2 ? handleSearch2() : handleSearch()} 
            disable={false}/>
              
            <div className={Visible ? "" : "effacer"}>
              <Button btnName="EFFACER" onClick={handleClearSearch} disable={false} />
            </div>
            
              <Button 
              btnName="NOUVELLE ATTRIBUTION" 
              onClick={toggleOpen}
              disable={false} />


              <MDBModal open={optXlModal} tabIndex='-1' onClose={() => setOptXlModal(false)}>
                <MDBModalDialog size='xl' >
                  <MDBModalContent id="contentm">
                    <MDBModalHeader>
                      <MDBModalTitle>Nouvelle attribution</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <NewAttribution isUserAlreadySelected={false} handleCancel={() => setOptXlModal(false)} location={'/inventaire/utilisateurs'}/>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
         
          </div>

          <div className="mainusers__box1__container__table">

            <TableUsers 
            users={filteredData} 
            onUserSelect={handleUserSelection} />

          </div>

        </div>

      </div>

      <div className="mainusers__menu">

        <Menu />

      </div>

    </div>
    
  );
};

export default Users;
